import { useShallow } from 'zustand/react/shallow';
import { mediaSorterAsc } from '../../../../lib/MediasLib';
import { MediaType } from '../../../../modules/media/mimeType';
import ProductAvatarRenderer from '../../../../modules/products/ProductAvatarRenderer';
import useGeneralSettingsStore from '../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { getMediaAspectRatio } from '../../../../utils/getMediaAspectRatio';
import ProductMediaEmptyState from '../ProductMediaEmptyState/ProductMediaEmptyState';

interface ProductThumbnailMedia {
  type: MediaType;
  position: number;
  url?: string;
}

interface ProductThumbnailProps {
  url?: string | null;
  medias?: ProductThumbnailMedia[];
  className?: string;
  size?: 'thumbnail' | 'card';
}

const resolveUrl = (url?: string | null, medias?: ProductThumbnailMedia[]) => {
  if (url) {
    return url;
  }

  return medias
    ?.filter((media) => media.type === 'IMAGE')
    .sort(mediaSorterAsc)
    .find((media) => media.url)?.url;
};

const ProductThumbnail = ({
  url,
  medias,
  className,
  size = 'thumbnail',
}: ProductThumbnailProps) => {
  const { mediaFormat } = useGeneralSettingsStore(
    useShallow((state) => ({ mediaFormat: state.generalSettings.mediaFormat })),
  );

  const resolvedUrl = resolveUrl(url, medias);

  if (!resolvedUrl) {
    return (
      <ProductMediaEmptyState
        size={size}
        aspectRatio={getMediaAspectRatio(mediaFormat)}
        className={className}
      />
    );
  }

  return <ProductAvatarRenderer url={resolvedUrl} className={className} />;
};

export default ProductThumbnail;
